/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { Component, ErrorInfo, ReactNode } from 'react'
import * as Sentry from '@sentry/browser'

import CustomError from 'views/CustomError'

interface State {
  hasError: boolean
}

// Error Boundaries exigem um componente de classe por usarem os métodos de ciclo de vida
// getDerivedStateFromError e componentDidCatch, que não possuem equivalentes em Hooks.
// Definição oficial do React: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
export class CustomSentryBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.captureException(error, { extra: { errorInfo } })

    // 2. Verifica se é um erro de carregamento de chunk
    const isChunkLoadError = error.name === 'ChunkLoadError' ||
      /loading chunk/i.test(error.message)

    // 3. Se for, força o recarregamento da página para buscar os novos assets
    if (isChunkLoadError) {
      window.location.reload()
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <CustomError
          title="Houve algo de errado."
          subtitle="Nosso time já foi notificado e está trabalhando para resolver o seu problema, nos desculpamos pelo inconveniente."
        />
      )
    }

    return this.props.children
  }
}
